module.exports = __webpack_public_path__ + "img/close-icon.634a2fd2.png";